// extracted by mini-css-extract-plugin
export default {"flex":"Shipper_flex__4e3T2","title":"Shipper_title__KLb5L","input_text":"Shipper_input_text__-IGc9"};